import { useEffect } from 'react'

import { stusdsWelcomeDialogConfig } from '../StusdsWelcomeDialog'
import { useTermsOfService } from '@/domain/state/compliance'
import { useCloseDialog, useOpenDialog } from '@/domain/state/dialogs/hooks'
import { useVisibility } from '@/domain/state/visibility'
import { useConnectedAddress } from '@/domain/wallet/useConnectedAddress'

const stusdsWelcomeDialogId = 'stusds-welcome-dialog'

export interface UseOpenStusdsWelcomeDialogParams {
  enabled: boolean
  chainId: number
}

export function useOpenStusdsWelcomeDialog({ enabled, chainId }: UseOpenStusdsWelcomeDialogParams): void {
  const { isVisible, setVisibility } = useVisibility(stusdsWelcomeDialogId)
  const openDialog = useOpenDialog()
  const closeDialog = useCloseDialog()
  const { account } = useConnectedAddress({ throwOnNotConnected: false })
  const { agreedToTermsOfService } = useTermsOfService()

  // ToS dialog can interfere with the welcome dialog, so we need to check if the user has agreed to the ToS
  const userAgreedToTermsOfService = account && agreedToTermsOfService(account)

  function onConfirm(): void {
    setVisibility(false)
    closeDialog()
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: no explanation
  useEffect(() => {
    if (!enabled) {
      return
    }

    if (isVisible && (userAgreedToTermsOfService || !account)) {
      openDialog(stusdsWelcomeDialogConfig, {
        onConfirm,
        chainId,
      })
    }
  }, [isVisible, userAgreedToTermsOfService, enabled])
}
